import { render, staticRenderFns } from "./HistoryEditNew.vue?vue&type=template&id=36d5e796&scoped=true"
import script from "./HistoryEditNew.vue?vue&type=script&lang=js"
export * from "./HistoryEditNew.vue?vue&type=script&lang=js"
import style0 from "./HistoryEditNew.vue?vue&type=style&index=0&id=36d5e796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5e796",
  null
  
)

export default component.exports